import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getHouseholdMemberForm = get(
  'guest.components.householdMemberForm'
);

export const getIsSaving = createSelector(
  getHouseholdMemberForm,
  get('saving')
);
export const getIsSaved = createSelector(getHouseholdMemberForm, get('saved'));
export const getSavingError = createSelector(
  getHouseholdMemberForm,
  get('savingError')
);
